import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

export default new vuex.Store({
    state:{
        loadingAm: false,
        routeName: ''
    },
    mutations: {
        switch_status(state, data) {
            state.loadingAm = data
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js